import { render, staticRenderFns } from "./AdminHealthBenefits.vue?vue&type=template&id=34175df9&scoped=true&"
import script from "./AdminHealthBenefits.vue?vue&type=script&lang=js&"
export * from "./AdminHealthBenefits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34175df9",
  null
  
)

export default component.exports